import React from "react";
export const RbacContext = /*#__PURE__*/React.createContext(null);